/**
 * Returns an array of HTMLElement children of @element matching @cssSelector, or empty array if not found.
 */
export function domQuerySelectorAll(element: HTMLElement, cssSelector: string): HTMLElement[] {
  return [].slice.call(element.querySelectorAll(cssSelector)).map((node: Element) => <HTMLElement>node);
}
